export interface PromptPart {
  text: string;
  /** True for a "[bracketed]" gap the visitor fills in by hand. */
  gap: boolean;
}

/** Splits a filled prompt into plain text and "[bracketed]" gaps, for highlighting. */
export function splitBracketGaps(text: string): PromptPart[] {
  return text
    .split(/(\[[^\]\n]+\])/)
    .filter((part) => part !== "")
    .map((part) => ({ text: part, gap: /^\[[^\]\n]+\]$/.test(part) }));
}
